import { forwardRef } from "react";
import { cn } from "@synthesis/shared-utils";
import { jsx } from "react/jsx-runtime";
//#region src/Input/Input.elements.tsx
const inputSizeClassName = {
	xs: "h-[1.75rem] rounded-lg text-sm",
	sm: "h-8 rounded-xl text-sm",
	md: "h-10 rounded-[.875rem] text-base",
	lg: "h-12 rounded-[.875rem] text-base"
};
const iconSizeClassName = {
	xs: "size-5",
	sm: "size-5",
	md: "size-6",
	lg: "size-6"
};
function Container({ className, children }) {
	return /* @__PURE__ */ jsx("div", {
		className: cn("[&_.input-error:focus-within]:outline-system-error-70 [&_.input-error:focus-within]:shadow-none [&_.input-error:focus-within]:outline [&_.input-error:focus-within]:outline-2 [&_.input-error:focus-within]:outline-offset-0", "[&_.input-error:focus-within]:shadow-[0px_0px_0px_4px_rgba(255,84,73,0.5)]", "[&_.input-valid]:outline-system-success-50 [&_.input-valid]:!outline [&_.input-valid]:outline-2 [&_.input-valid]:outline-offset-0", "[&_.input-valid:focus-within]:shadow-[0px_0px_0px_4px_rgba(18,199,134,0.5)]", className),
		children
	});
}
const StyledInputWrapper = forwardRef(({ size, disabled, readOnly, withError, className, children }, ref) => /* @__PURE__ */ jsx("div", {
	ref,
	className: cn("bg-neutrals-95 flex items-center gap-2 border-2 border-solid border-transparent px-3", "focus-within:outline-system-info-70 focus-within:outline focus-within:outline-2 focus-within:outline-offset-1", inputSizeClassName[size], disabled && "bg-neutrals-80", readOnly && "bg-neutrals-80", withError && "border-system-error-50", className),
	children
}));
StyledInputWrapper.displayName = "StyledInputWrapper";
function StyledLabel({ disabled, className, children, ...props }) {
	return /* @__PURE__ */ jsx("label", {
		className: cn("paragraph-sm text-type-common block pb-2", disabled && "text-[#998E8E] opacity-40", className),
		...props,
		children
	});
}
function StyledLeftIconWrapper({ size, className, children }) {
	return /* @__PURE__ */ jsx("div", {
		className: cn("text-neutrals-60 flex items-center justify-center", iconSizeClassName[size], className),
		children
	});
}
const StyledInput = forwardRef(({ disabled, className, ...props }, ref) => /* @__PURE__ */ jsx("input", {
	ref,
	className: cn("w-full bg-transparent text-inherit outline-none", disabled && "placeholder:text-[#998E8E]", className),
	...props
}));
StyledInput.displayName = "StyledInput";
//#endregion
export { Container, StyledInput, StyledInputWrapper, StyledLabel, StyledLeftIconWrapper };

//# sourceMappingURL=Input.elements.js.map